module.exports = __webpack_public_path__ + "static/media/transforming-nuneaton-1.f3327aa4.png";